import { cn } from "@/lib/utils";

type ProgressStepsProps = {
  /** 1-based current step */
  step: number;
  total?: number;
  className?: string;
  onStepSelect?: (step: number) => void;
};

export function ProgressSteps({
  step,
  total = 3,
  className,
  onStepSelect,
}: ProgressStepsProps) {
  return (
    <div className={cn("flex items-center", className)} aria-label="Progress">
      {Array.from({ length: total }, (_, index) => {
        const current = index + 1;
        const reached = step >= current;
        const complete = step > current;
        return (
          <div key={current} className="flex items-center">
            {onStepSelect ? (
              <button
                type="button"
                onClick={() => onStepSelect(current)}
                aria-current={step === current ? "step" : undefined}
                className={cn(
                  "flex size-9 items-center justify-center rounded-full font-heading text-sm transition-colors",
                  reached
                    ? "bg-primary text-primary-foreground"
                    : "bg-[#f3f1ec] text-primary/45",
                )}
              >
                {current}
              </button>
            ) : (
              <div
                className={cn(
                  "flex size-9 items-center justify-center rounded-full font-heading text-sm",
                  reached
                    ? "bg-primary text-primary-foreground"
                    : "bg-[#f3f1ec] text-primary/45",
                )}
              >
                {current}
              </div>
            )}
            {current < total ? (
              <div
                className={cn(
                  "h-1 w-10 sm:w-14",
                  complete ? "bg-primary" : "bg-[#f3f1ec]",
                )}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
